import { render } from "./MaklersOfPropertyView.vue?vue&type=template&id=6e00354c"
import script from "./MaklersOfPropertyView.vue?vue&type=script&lang=js"
export * from "./MaklersOfPropertyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__